import { css } from 'styled-system/css';

export const voucherPromoModalStyle = {
	voucherPromoModal: css({
		'& .modal__container': {
			w: '100%',
		}
	}),

	background: css({
		maxW: '1450px',
		w: '100%',
		h: '100vh',
		m: '0 auto',
		position: 'relative',
	}),

	container: css({
		position: 'absolute', 
		top: 'var(--header-height)',
		w: '375px',
		h: '520px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		_ltr: {
			right: '0',
		},
		_rtl: {
			left: '0',
		},
	}),

	headlessContainer: css({
		md: {
			left: '240px',
			right: 'auto',
			top: '0 !important',

		}
	}),

	voucherIconBg: css({
		padding: '5px',
		border: '2px solid #EB9A3B',
		borderRadius: '100%',
		position: 'absolute',
		top: '8px',
		_ltr: {
			right: '15px',
		},
		_rtl: {
			left: '15px',
		},

		_light: {
			background: 'white',
		},
		_mars: {
			right: '40px',
			top: '10px',
		},
	}),

	voucherIcon: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '100%',
		width: '38px',
		height: '38px',
		background: 'var(--s400)',

		_light: {
			background: 'var(--p500)',
		},

		_mars: {
			background: 'primary.500'
		},     

		'& .icon': {
			width: '32px',
			height: '32px',
			color: 'whiteOpacity.100',
		}
	}),
    
	arrowImg: css({
		w: '108px',
		position: 'absolute',

		base: {
			top: ' 50px',
			_ltr: {
				transform: 'rotate(8deg)',
				right: '70px',
			},
			_rtl: {
				transform: 'rotate(-92deg)',
				left: '70px',
			},
		},

		_mars: {
			top: '62px',
			right: '83px',
			transform: 'rotate(-3deg)',   
		}
	}),

	content: css({
		marginTop: '163px',

		_mars: {
			marginTop: '186px',
		},
	}),

	text: css({
		textAlign: 'center',
		fontSize: '20px',
		fontWeight: '800',
		color: 'whiteOpacity.100',
	}),

	button: css({
		mt: '30px',
		h: '39px',
		w: '168px',
		fontSize: '14px',
		fontWeight: '700',

		_mars: {
			borderRadius: '6px',
			backgroundColor: 'primary.500',
		}
	}),
}